import { React } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { PATH } from '../../../constants';
import { ReactComponent as Icon } from '../../../img/readmore-arrow.svg';

const LinkMore = ({
    contentId,
    anchor = null,
    name = null,
    labelledBy = null,
    additionalClassNames = null
}) => {
    const { t } = useTranslation();

    const linkClasses = classNames('link', 'link--more', additionalClassNames);

    const defaultTitle = `${t('ui.linkMore.title')}`;
    const defaultText = `${t('ui.linkMore.text')}`;

    return (
        <Link
            title={name || defaultTitle}
            className={linkClasses}
            to={`${PATH.helpAndSupport}/${contentId}`}
            aria-labelledby={labelledBy}
        >
            {anchor || defaultText} {name && <span className="sr-only">{name}</span>}
            <Icon className="icon icon--xxxs" aria-hidden="true" />
        </Link>
    );
};

export default LinkMore;
